import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import AgenteIaHotel from "@/pages/AgenteIaHotel";

export const Route = createFileRoute("/agente-ia-hotel")({
  head: () => buildHead({
    title: "Agente de IA para Hotel: mais reserva direta, menos comissão",
    description: "Agente de IA que responde tarifas, tira dúvidas e converte reservas diretas do seu hotel ou pousada no WhatsApp e no Instagram, 24h e em vários idiomas. CRM incluso.",
    path: "/agente-ia-hotel",
  }),
  component: AgenteIaHotel,
});
